import '@/assets/styles/base.css'
// 关于路由
import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { unstable_HistoryRouter as HistoryRouter, Routes, Route } from 'react-router-dom'
import history, { isMobileFu } from './utils/history'
import SpinLoding from './components/SpinLoding'
import AsyncSpinLoding from './components/AsyncSpinLoding'

import UpAsyncLoding from './components/UpAsyncLoding'
import MessageCom from './components/Message'

import screenImg from '@/assets/img/landtip.png'
import store, { RootState } from './store'
import { Image } from 'antd'

const A1home = React.lazy(() => import('./pages/A1home'))
const A2layout = React.lazy(() => import('./pages/A2layout'))
const A3jieyu = React.lazy(() => import('./pages/A3jieyu'))
export default function App() {
  // 从仓库中获取查看图片的信息
  const lookBigImg = useSelector((state: RootState) => state.A0Layout.lookBigImg)

  const rootDomFu = useCallback(() => {
    const rootDom: HTMLDivElement = document.querySelector('#root')!
    if (rootDom) {
      rootDom.style.height = window.innerHeight + 'px'
    }
  }, [])

  useEffect(() => {
    window.addEventListener('resize', rootDomFu, true)
    rootDomFu()
  }, [rootDomFu])

  return (
    <>
      {/* 关于路由 */}
      <HistoryRouter history={history}>
        <React.Suspense fallback={<SpinLoding />}>
          <Routes>
            <Route path='/' element={<A1home />} />
            <Route path='/layout' element={<A2layout />} />
            <Route path='/jieyu' element={<A3jieyu />} />
          </Routes>
        </React.Suspense>
      </HistoryRouter>

      {/* 发送请求的加载组件 */}
      <AsyncSpinLoding />

      {/* 所有图片点击预览查看大图 */}
      <Image
        style={{ display: 'none' }}
        preview={{
          visible: lookBigImg.show,
          src: lookBigImg.url,
          onVisibleChange: vis => {
            if (vis) return
            store.dispatch({
              type: 'layout/lookBigImg',
              payload: { url: '', show: false }
            })
          }
        }}
      />

      {/* 上传附件的进度条元素 */}
      <UpAsyncLoding />

      {/* 查看视频音频 */}
      {/* <LookDom /> */}

      {/* antd 轻提示 ---兼容360浏览器 */}
      <MessageCom />

      {/* 横屏提示 */}
      {isMobileFu() ? (
        <div id='ScreenChange'>
          <img src={screenImg} alt='' />
          <p>请在竖屏模式浏览</p>
        </div>
      ) : null}
    </>
  )
}
